import { MyNaviDialogQuestionnaire } from '@/components/Campaign/mynavi/MyNaviDialogQuestionnaire/MyNaviDialogQuestionnaire'
import { useApi } from '@/components/Functional/hooks-core/useApi'
import { AppMachineContext } from '@/components/Functional/hooks-core/useRaundLifeCycle'
import { ApiError } from '@/components/Functional/lib/request'
// ここにMyNaviModeを持ってくるのはちょっとイマイチだが、全体の流れとしてここが一番良いため持ってきている
import { isMynaviMode } from '@/components/Functional/utils/campaignTypes'
import { DialogQuestionnaire } from '@/components/Layout/questionnaire/DialogQuestionnaire'
import type { QuestionnaireAnswerFormData } from '@/schemas/forms'
import { useSelector } from '@xstate/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const InitialQuestionnaireInAppMachineContext = () => {
  const appActorRef = AppMachineContext.useActorRef()
  const questionnaire = useSelector(appActorRef, (s) => s.context.questionnaire)
  const isLoginQuestionnaireExists = useSelector(appActorRef, (s) => s.context.isLoginQuestionnaireExists)
  const isShowingQuestionnaire = useSelector(appActorRef, (s) =>
    s.matches({ phase3: { flow: 'showingQuestionnaire' } }),
  )

  const api = useApi()
  const { t } = useTranslation()

  const [submitError, setSubmitError] = useState<string | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const resolveErrorMessage = (err: unknown): string => {
    if (err instanceof ApiError) {
      if (err.status === 409) {
        return t('register_questionnaire.submit_error_conflict', 'このアンケートはすでに回答済みです。')
      }
      if (err.status === 400 || err.status === 422) {
        // サーバーが返した具体的なメッセージがあれば優先表示する
        const serverMessage = (err.body as { error?: { message?: string } } | undefined)?.error?.message
        if (serverMessage) {
          return serverMessage
        }
        return t(
          'register_questionnaire.submit_error_validation',
          '入力内容にエラーがあります。内容を確認してください。',
        )
      }
    }
    return t('register_questionnaire.submit_error', '送信に失敗しました。もう一度お試しください。')
  }

  const handleFirstQuestionnaireSubmit = async (formData: QuestionnaireAnswerFormData): Promise<boolean> => {
    const questionnaireId = questionnaire?.id
    if (!questionnaireId) {
      appActorRef.send({ type: 'QUESTIONNAIRE_SUBMITTED' })
      return true
    }
    const answers = Object.entries(formData).map(([itemId, value]) => ({
      itemId: Number.parseInt(itemId, 10),
      answer: Array.isArray(value) ? value : value ? [value] : [],
    }))

    setIsSubmitting(true)
    setSubmitError(null)
    try {
      await api.auth.postQuestionnaireAnswer(questionnaireId, {
        questionnaireId,
        answers,
      })
      appActorRef.send({ type: 'QUESTIONNAIRE_SUBMITTED' })
      return true
    } catch (err) {
      setSubmitError(resolveErrorMessage(err))
      return false
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      {isMynaviMode() ? (
        <MyNaviDialogQuestionnaire
          questionnaire={questionnaire}
          isOpen={isShowingQuestionnaire}
          isSubmitting={isSubmitting}
          submitError={submitError}
          onClose={() => appActorRef.send({ type: 'QUESTIONNAIRE_SUBMITTED' })}
          onSubmit={handleFirstQuestionnaireSubmit}
        />
      ) : (
        <DialogQuestionnaire
          questionnaire={questionnaire}
          isOpen={isShowingQuestionnaire}
          isSubmitting={isSubmitting}
          submitError={submitError}
          onClose={() => appActorRef.send({ type: 'QUESTIONNAIRE_SUBMITTED' })}
          onSubmit={handleFirstQuestionnaireSubmit}
        />
      )}
    </>
  )
}
